/* istanbul ignore file */
import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ tabs: { defaultTabBorderColor } }: ComposedTheme) => ({
  tabs: {
    position: 'relative',
    whiteSpace: 'nowrap',
    overflowY: 'hidden',
    overflowX: 'auto',
  },
  wrapper: {
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingTop: 9,
    display: 'flex',
  },
  leftOverflow: {
    background: 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
    width: 40,
    height: 67,
    display: 'block',
    zIndex: 10,
    position: 'absolute',
    left: 0,
    top: 0,
  },
  rightOverflow: {
    background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
    width: 40,
    height: 67,
    zIndex: 10,
    display: 'block',
    position: 'absolute',
    right: 0,
    top: 0,
  },
  startLine: {
    display: 'inline-block',
    backgroundColor: defaultTabBorderColor,
    width: 15,
    height: 1,
    position: 'relative',
    top: 55,
    '&::after': {
      content: '""',
      position: 'absolute',
      width: 1,
      height: 4,
      top: -3,
      right: -1,
      display: 'block',
      backgroundColor: defaultTabBorderColor,
    },
  },
  endLine: {
    maxWidth: 128,
    display: 'inline-block',
    backgroundColor: defaultTabBorderColor,
    width: '100%',
    height: 1,
    position: 'relative',
    top: 55,
    '&::before': {
      content: '""',
      position: 'absolute',
      width: 1,
      height: 4,
      top: -4,
      left: 0,
      display: 'block',
      backgroundColor: defaultTabBorderColor,
    },
  },
});

export default createUseStyles(styles);
